import PropTypes from "prop-types"
import React, { useState } from "react"

import Button from "src/components/Button"

import LoginForm from "./LoginForm"
import MagicLinkLoginForm from "./MagicLinkLoginForm"

const Login = ({ handleClose }) => {
  const [loginWithMagicLink, setLoginWithMagicLink] = useState(false)
  return (
    <>
      {loginWithMagicLink ? <MagicLinkLoginForm /> : <LoginForm />}
      <div className="mt-4 flex flex-col items-center justify-center space-y-4">
        <div className="w-full border-b" />
        <div className="flex w-full justify-between space-x-2">
          {Boolean(handleClose) && (
            <Button onClick={handleClose}>Cancel</Button>
          )}
          {loginWithMagicLink ? (
            <Button
              fullWidth={Boolean(!handleClose)}
              onClick={() => setLoginWithMagicLink(false)}
            >
              Log in with email and password
            </Button>
          ) : (
            <Button
              fullWidth={Boolean(!handleClose)}
              onClick={() => setLoginWithMagicLink(true)}
            >
              Log in with magic link
            </Button>
          )}
        </div>
      </div>
    </>
  )
}

Login.propTypes = {
  handleClose: PropTypes.func,
}

export default Login
